module.exports = __webpack_public_path__ + "static/img/011.eb162d50.png";